{
  "$schema": "../../schemas/shared-rules.schema.json",
  "namespace": "award-adjustment",
  "templates": {
    "clearAdjustmentFields": {
      "watch": "{{prefix}}/properties/methodType",
      "condition": {
        "field": "{{prefix}}/properties/methodType",
        "isEmpty": true
      },
      "clear": [
        "{{prefix}}/properties/asOfDate",
        "{{prefix}}/properties/residualDate",
        "{{prefix}}/properties/amortizationDate",
        "{{prefix}}/properties/cancelShareTypeId",
        "{{prefix}}/properties/targetCancelled",
        "{{prefix}}/properties/adjustmentReason",
        "{{prefix}}/properties/awardAdjustmentMethodId"
      ]
    },
    "clearCancelShareTypeOnManualTargetCancelled": {
      "watch": "{{prefix}}/properties/targetCancelled",
      "mode": "edit",
      "clear": [
        "{{prefix}}/properties/cancelShareTypeId"
      ]
    },
    "copyAsOfToResidual": {
      "watch": "{{prefix}}/properties/asOfDate",
      "set": {
        "{{prefix}}/properties/residualDate": {
          "operator": "field",
          "name": "asOfDate"
        }
      }
    },
    "resolveAdjustmentMethodOnMethodType": {
      "watch": "{{prefix}}/properties/methodType",
      "runOnMount": true,
      "condition": {
        "field": "{{prefix}}/properties/methodType",
        "notEmpty": true
      },
      "mode": "edit",
      "lookup": {
        "actionId": "RESOLVE_AWARD_ADJUSTMENT_METHOD",
        "paramField": "methodType",
        "params": {
          "methodType": "methodType"
        },
        "cache": "immutable"
      },
      "mapTo": {
        "awardAdjustmentMethodId": "awardAdjustmentMethodId"
      }
    },
    "adjustAwardOnCancelShareType": {
      "watch": "{{prefix}}/properties/cancelShareTypeId",
      "condition": {
        "allOf": [
          { "field": "{{prefix}}/properties/methodType", "notEmpty": true },
          { "field": "{{prefix}}/properties/asOfDate", "notEmpty": true },
          { "field": "{{prefix}}/properties/cancelShareTypeId", "notEmpty": true }
        ]
      },
      "mode": "edit",
      "lookup": {
        "actionId": "{{adjustmentActionId}}",
        "paramField": "cancelShareTypeId",
        "params": {
          "methodType": "methodType",
          "awardAdjustmentMethodId": "awardAdjustmentMethodId",
          "asOfDate": "asOfDate",
          "cancelShareTypeId": "cancelShareTypeId",
          "participantId": "participantId",
          "awardId": "id"
        },
        "rejectIfTouched": false
      },
      "mapTo": {
        "targetCancelled": "targetCancelled"
      },
      "debounceMs": 500
    },
    "adjustAwardOnMethodType": {
      "watch": "{{prefix}}/properties/methodType",
      "condition": {
        "allOf": [
          { "field": "{{prefix}}/properties/methodType", "notEmpty": true },
          { "field": "{{prefix}}/properties/asOfDate", "notEmpty": true },
          { "field": "{{prefix}}/properties/cancelShareTypeId", "notEmpty": true }
        ]
      },
      "mode": "edit",
      "lookup": {
        "actionId": "{{adjustmentActionId}}",
        "paramField": "methodType",
        "params": {
          "methodType": "methodType",
          "awardAdjustmentMethodId": "awardAdjustmentMethodId",
          "asOfDate": "asOfDate",
          "cancelShareTypeId": "cancelShareTypeId",
          "participantId": "participantId",
          "awardId": "id"
        },
        "rejectIfTouched": false
      },
      "mapTo": {
        "targetCancelled": "targetCancelled"
      },
      "debounceMs": 500
    },
    "adjustAwardOnAsOfDate": {
      "watch": "{{prefix}}/properties/asOfDate",
      "condition": {
        "allOf": [
          { "field": "{{prefix}}/properties/methodType", "notEmpty": true },
          { "field": "{{prefix}}/properties/asOfDate", "notEmpty": true },
          { "field": "{{prefix}}/properties/cancelShareTypeId", "notEmpty": true }
        ]
      },
      "mode": "edit",
      "lookup": {
        "actionId": "{{adjustmentActionId}}",
        "paramField": "asOfDate",
        "params": {
          "methodType": "methodType",
          "awardAdjustmentMethodId": "awardAdjustmentMethodId",
          "asOfDate": "asOfDate",
          "cancelShareTypeId": "cancelShareTypeId",
          "participantId": "participantId",
          "awardId": "id"
        },
        "rejectIfTouched": false
      },
      "mapTo": {
        "targetCancelled": "targetCancelled"
      },
      "debounceMs": 500
    },
    "rule_asOfDate_required": {
      "target": "{{prefix}}/properties/asOfDate",
      "rule": "required",
      "condition": {
        "field": "{{prefix}}/properties/methodType",
        "notEmpty": true
      },
      "message": "Required field"
    },
    "rule_targetCancelled_required": {
      "target": "{{prefix}}/properties/targetCancelled",
      "rule": "required",
      "condition": {
        "allOf": [
          { "field": "{{prefix}}/properties/methodType", "notEmpty": true },
          { "field": "{{prefix}}/properties/cancelShareTypeId", "isEmpty": true }
        ]
      },
      "message": "Required field"
    }
  }
}
